import type { ReactNode } from 'react';

export default function Empty({
  title, hint, icon,
}: { title: string; hint?: string; icon?: ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      {icon && <div className="text-slate-600 mb-3">{icon}</div>}
      <div className="text-slate-300 font-medium">{title}</div>
      {hint && <div className="text-sm text-slate-500 mt-1 max-w-sm">{hint}</div>}
    </div>
  );
}
